import { UserDto } from "@resume-studio/dto";
import { create } from "zustand";

type AuthState = {
  user: UserDto | null;
};

type AuthActions = {
  setUser: (user: UserDto | null) => void;
};

// Intentionally NOT persisted (unlike the consumer app's auth store). The
// admin SPA always defers to `/api/admin/auth/me` for source-of-truth on
// every full-page load — we don't want a stale localStorage entry to flash
// a non-admin into the admin chrome on cold load.
export const useAuthStore = create<AuthState & AuthActions>((set) => ({
  user: null,
  setUser: (user) => {
    set({ user });
  },
}));
